var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NikePrivacy_accessToken, _NikePrivacy_guestLocation, _NikePrivacy_language, _NikePrivacy_userId, _NikePrivacy_PrivacyServicesInstance, _NikePrivacy_memberLocation, _NikePrivacy_isEnabledState, _NikePrivacy_isCPRAEnabledState, _NikePrivacy_packageVersion, _NikePrivacy_initializationPromiseParams, _NikePrivacy_initializationPromise;
import { CONTEXT_FRAME_NAMES, dispatchEvent, getPrivacyCoreEventName, PRIVACY_CORE_CUSTOM_EVENT_NAMES, PURPOSE_LIMITATION_NAMES, SERVER_CONTEXT_FRAME_NAMES, SERVER_PURPOSE_LIMITATION_NAMES, RELIC_EVENT_NAME, checkIsModalVisible, addRelicAnalyticsPageAction, getRelicUserType, getRelicGeolocation, } from '@nike/privacy-shared-logic';
import { PrivacyServices } from './services/privacyServices';
import { CLEAR_BROWSER_STORAGE_MESSAGE, LOG_LABEL_STYLES } from './constants';
export class NikePrivacy {
    constructor(store) {
        _NikePrivacy_accessToken.set(this, void 0);
        _NikePrivacy_guestLocation.set(this, void 0);
        _NikePrivacy_language.set(this, void 0);
        _NikePrivacy_userId.set(this, void 0);
        _NikePrivacy_PrivacyServicesInstance.set(this, void 0);
        _NikePrivacy_memberLocation.set(this, undefined);
        _NikePrivacy_isEnabledState.set(this, undefined);
        _NikePrivacy_isCPRAEnabledState.set(this, undefined);
        _NikePrivacy_packageVersion.set(this, process.env.PACKAGE_VERSION);
        _NikePrivacy_initializationPromiseParams.set(this, {
            resolve: undefined,
            reject: undefined,
            initializationError: undefined,
        });
        _NikePrivacy_initializationPromise.set(this, new Promise((resolve, reject) => {
            __classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f").resolve = resolve;
            __classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f").reject = reject;
        }).catch(error => {
            __classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f").initializationError = error;
            return Promise.resolve(false);
        }));
        this.__clearBrowserStorage__ = () => {
            __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").clearBrowserDataRelatedToPrivacy();
            console.log(`%c  Result:  `, LOG_LABEL_STYLES.INFO, CLEAR_BROWSER_STORAGE_MESSAGE);
        };
        this.initialize = async ({ webShellIdentity, country: location, language, }) => {
            var _a, _b, _c, _d, _e;
            try {
                if (typeof __classPrivateFieldGet(this, _NikePrivacy_isEnabledState, "f") === 'undefined') {
                    this.isEnabled;
                }
                if (typeof __classPrivateFieldGet(this, _NikePrivacy_isCPRAEnabledState, "f") === 'undefined') {
                    this.isCPRAEnabled;
                }
                if (!__classPrivateFieldGet(this, _NikePrivacy_isEnabledState, "f")) {
                    throw new Error('NikePrivacy is not allowed to use');
                }
                if (typeof NikePrivacy._userExperience === 'undefined') {
                    throw new Error('user experience is not defined in .env file');
                }
                if (!webShellIdentity) {
                    throw new Error('web shell identity does not exist');
                }
                if (NikePrivacy._initializedInstance) {
                    return await NikePrivacy._initializedInstance;
                }
                __classPrivateFieldSet(this, _NikePrivacy_guestLocation, location, "f");
                __classPrivateFieldSet(this, _NikePrivacy_language, __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").getLanguage(language), "f");
                __classPrivateFieldSet(this, _NikePrivacy_accessToken, await webShellIdentity.getAccessToken(), "f");
                __classPrivateFieldSet(this, _NikePrivacy_memberLocation, __classPrivateFieldGet(this, _NikePrivacy_accessToken, "f")
                    ? (_a = (await webShellIdentity.getUserProfile())) === null || _a === void 0 ? void 0 : _a.registeredCountry
                    : '', "f");
                __classPrivateFieldSet(this, _NikePrivacy_userId, await __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").getUserId(__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"), webShellIdentity), "f");
                const initializedResponse = __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").initialize({
                    accessToken: __classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"),
                    userId: __classPrivateFieldGet(this, _NikePrivacy_userId, "f"),
                    language: __classPrivateFieldGet(this, _NikePrivacy_language, "f"),
                    userExperience: NikePrivacy._userExperience,
                    guestLocation: __classPrivateFieldGet(this, _NikePrivacy_guestLocation, "f"),
                    memberLocation: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f"),
                });
                NikePrivacy._initializedInstance = initializedResponse;
                const initializeResult = await initializedResponse;
                (_c = (_b = __classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f")).resolve) === null || _c === void 0 ? void 0 : _c.call(_b, true);
                return initializeResult;
            }
            catch (error) {
                dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.INITIALIZE_ERROR));
                addRelicAnalyticsPageAction(RELIC_EVENT_NAME.INITIALIZE_ERROR, {
                    user_type: getRelicUserType(!!__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f")),
                    error_message: `${error}`,
                    geolocation: getRelicGeolocation(),
                    ...(__classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") && { registered_country: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") }),
                });
                (_e = (_d = __classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f")).reject) === null || _e === void 0 ? void 0 : _e.call(_d, error);
                return Promise.resolve(undefined);
            }
            finally {
                dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.INITIALIZED));
            }
        };
        this.permissions = {
            name: PURPOSE_LIMITATION_NAMES,
            get: (name, uniqueEventsPrefix) => {
                try {
                    if (typeof NikePrivacy._initializedInstance === 'undefined')
                        throw new Error('NikePrivacy is not initialized');
                    if (typeof name === 'undefined') {
                        const permissionsAll = __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").getPermissionsAll(__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"));
                        if (!permissionsAll)
                            throw new Error('Can not get all permissions');
                        return permissionsAll;
                    }
                    const permissions = Object.keys(PURPOSE_LIMITATION_NAMES).reduce((previousValue, currentValue) => {
                        previousValue[PURPOSE_LIMITATION_NAMES[currentValue]] = () => __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").getPermission({
                            name: SERVER_PURPOSE_LIMITATION_NAMES[currentValue],
                            accessToken: __classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"),
                        });
                        return previousValue;
                    }, {});
                    if (!(name in permissions))
                        throw new Error('Can not get permission');
                    return permissions[name]();
                }
                catch (error) {
                    dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_GET_ERROR, uniqueEventsPrefix !== null && uniqueEventsPrefix !== void 0 ? uniqueEventsPrefix : ''));
                    addRelicAnalyticsPageAction(RELIC_EVENT_NAME.PERMISSIONS_GET_ERROR, {
                        user_type: getRelicUserType(!!__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f")),
                        error_message: `${error}`,
                        geolocation: getRelicGeolocation(),
                        ...(__classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") && { registered_country: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") }),
                    });
                    return;
                }
            },
        };
        this.interactions = {
            get: (name, uniqueEventsPrefix = '') => {
                try {
                    if (typeof NikePrivacy._initializedInstance === 'undefined')
                        throw new Error('NikePrivacy is not initialized');
                    const interactions = Object.keys(CONTEXT_FRAME_NAMES).reduce((previousValue, currentValue) => {
                        previousValue[CONTEXT_FRAME_NAMES[currentValue]] = () => __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").getInteraction({
                            name: SERVER_CONTEXT_FRAME_NAMES[currentValue],
                            accessToken: __classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"),
                        });
                        return previousValue;
                    }, {});
                    if (!interactions[name])
                        throw new Error('Can not get interaction');
                    return interactions[name]();
                }
                catch (error) {
                    dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.CONTEXT_FRAMES_GET_ERROR, uniqueEventsPrefix));
                    addRelicAnalyticsPageAction(RELIC_EVENT_NAME.CONTEXT_FRAMES_GET_ERROR, {
                        user_type: getRelicUserType(!!__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f")),
                        error_message: `${error}`,
                        geolocation: getRelicGeolocation(),
                        ...(__classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") && { registered_country: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") }),
                    });
                    return;
                }
            },
            set: async (contextFrameToUpdate, uniqueEventsPrefix = '', captureInitialConsent = false) => {
                try {
                    if (typeof NikePrivacy._initializedInstance === 'undefined')
                        throw new Error('NikePrivacy is not initialized');
                    const requestResponse = await __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").setInteraction({
                        accessToken: __classPrivateFieldGet(this, _NikePrivacy_accessToken, "f"),
                        language: __classPrivateFieldGet(this, _NikePrivacy_language, "f"),
                        guestLocation: __classPrivateFieldGet(this, _NikePrivacy_guestLocation, "f"),
                        memberLocation: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f"),
                        userId: __classPrivateFieldGet(this, _NikePrivacy_userId, "f"),
                        contextFrameToUpdate,
                        userExperience: NikePrivacy._userExperience,
                        uniqueEventsPrefix,
                        captureInitialConsent,
                    });
                    dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATED, uniqueEventsPrefix));
                    return requestResponse;
                }
                catch (error) {
                    dispatchEvent(getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATE_ERROR, uniqueEventsPrefix));
                    addRelicAnalyticsPageAction(RELIC_EVENT_NAME.PERMISSIONS_UPDATE_ERROR, {
                        user_type: getRelicUserType(!!__classPrivateFieldGet(this, _NikePrivacy_accessToken, "f")),
                        error_message: `${error}`,
                        geolocation: getRelicGeolocation(),
                        ...(__classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") && { registered_country: __classPrivateFieldGet(this, _NikePrivacy_memberLocation, "f") }),
                    });
                    return Promise.resolve(undefined);
                }
            },
        };
        __classPrivateFieldSet(this, _NikePrivacy_PrivacyServicesInstance, new PrivacyServices(store), "f");
    }
    get __VERSION__() {
        return __classPrivateFieldGet(this, _NikePrivacy_packageVersion, "f") || '';
    }
    get isEnabled() {
        try {
            __classPrivateFieldSet(this, _NikePrivacy_isEnabledState, __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").checkIsEnabled(), "f");
            return __classPrivateFieldGet(this, _NikePrivacy_isEnabledState, "f");
        }
        catch (error) {
            return false;
        }
    }
    get isCPRAEnabled() {
        try {
            __classPrivateFieldSet(this, _NikePrivacy_isCPRAEnabledState, __classPrivateFieldGet(this, _NikePrivacy_PrivacyServicesInstance, "f").checkIsCPRAEnabled(), "f");
            return __classPrivateFieldGet(this, _NikePrivacy_isCPRAEnabledState, "f");
        }
        catch (error) {
            return false;
        }
    }
    get isModalVisible() {
        return checkIsModalVisible();
    }
    isInitialized() {
        if (__classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f").initializationError) {
            return Promise.reject(__classPrivateFieldGet(this, _NikePrivacy_initializationPromiseParams, "f").initializationError);
        }
        return __classPrivateFieldGet(this, _NikePrivacy_initializationPromise, "f");
    }
}
_NikePrivacy_accessToken = new WeakMap(), _NikePrivacy_guestLocation = new WeakMap(), _NikePrivacy_language = new WeakMap(), _NikePrivacy_userId = new WeakMap(), _NikePrivacy_PrivacyServicesInstance = new WeakMap(), _NikePrivacy_memberLocation = new WeakMap(), _NikePrivacy_isEnabledState = new WeakMap(), _NikePrivacy_isCPRAEnabledState = new WeakMap(), _NikePrivacy_packageVersion = new WeakMap(), _NikePrivacy_initializationPromiseParams = new WeakMap(), _NikePrivacy_initializationPromise = new WeakMap();
NikePrivacy._userExperience = process.env.USER_EXPERIENCE;
